
// import { useEffect, useRef, useState } from "react";
// import Cookies from "js-cookie";
// import Swal from "sweetalert2";
// import { calculateTimeLeft, formatTime, getTokenExpiry } from "./TimeUtility";
// import { config } from "./CommonURLS";
// import axios from "axios";
// export default function SessionTimer({ onLogout, onProgress }) {
//     const refreshExpiry = Number(Cookies?.get("refreshTokenTime"));
//     const [timeLeft, setTimeLeft] = useState("--:--");
//     const [progress, setProgress] = useState(100);
//     const timerRef = useRef(null);
//     const alertShownRef = useRef(false);
//     const initialDuration = refreshExpiry ? refreshExpiry - Date.now() : 0;
//     useEffect(() => {
//         startTimer();
//         return () => clearInterval(timerRef.current);
//         // eslint-disable-next-line
//     }, [refreshExpiry]);

//     const startTimer = () => {
//         if (!refreshExpiry) return;

//         const updateTimer = () => {
//             const remaining = calculateTimeLeft(refreshExpiry);
//             setTimeLeft(formatTime(remaining));

//             const newProgress =
//                 initialDuration > 0
//                     ? Math.max(0, (remaining / initialDuration) * 100)
//                     : 0;

//             setProgress(newProgress);

//             // ✅ ONLY ADD THIS LINE
//             if (onProgress) onProgress(newProgress);

//             // if (remaining <= 0 && !alertShownRef.current) {
//             //     alertShownRef.current = true;
//             //     clearInterval(timerRef.current);

//             //     Swal.fire({
//             //         title: "Session Expired",
//             //         text: "Please login again",
//             //         icon: "warning",
//             //         confirmButtonText: "OK",
//             //         allowOutsideClick: false,
//             //     }).then(() => onLogout());
//             // }
//             // ✅ 10 sec mundu warning popup
//             if (
//                 remaining <= 50000 &&
//                 remaining > 0 &&
//                 !alertShownRef.current
//             ) {

//                 alertShownRef.current = true;

//                 clearInterval(timerRef.current);

//                 Swal.fire({
//                     title: "Session Expiring Soon",
//                     text: "Your session will expire in 10 seconds. Continue session?",
//                     icon: "warning",
//                     showCancelButton: true,
//                     confirmButtonText: "Continue Session",
//                     cancelButtonText: "Logout",
//                     allowOutsideClick: false,
//                 }).then(async (result) => {

//                     // ✅ user continue click cheste
//                     if (result.isConfirmed) {

//                         try {

//                             const refreshToken =
//                                 Cookies.get("refreshToken");

//                             // ✅ refresh token lekapothe logout
//                             if (!refreshToken) {

//                                 onLogout();

//                                 return;
//                             }

//                             const URL =
//                                 config.url.FAC_URL +
//                                 "auth/refresh-token";

//                             const res = await axios.post(URL, {
//                                 refreshToken,
//                             });

//                             console.log(
//                                 "REFRESH RESPONSE",
//                                 res
//                             );

//                             // ✅ response structure batti
//                             const acToken =
//                                 res?.data?.data?.accessToken ||
//                                 res?.data?.accessToken;

//                             const rfToken =
//                                 res?.data?.data?.refreshToken ||
//                                 res?.data?.refreshToken;

//                             // ✅ invalid response
//                             if (!acToken || !rfToken) {

//                                 console.log(
//                                     "Invalid refresh response"
//                                 );

//                                 onLogout();

//                                 return;
//                             }

//                             // ✅ new tokens set
//                             Cookies.set("token", acToken);

//                             Cookies.set(
//                                 "refreshToken",
//                                 rfToken
//                             );

//                             // ✅ new expiry set
//                             Cookies.set(
//                                 "tokenTime",
//                                 getTokenExpiry(acToken)
//                             );

//                             Cookies.set(
//                                 "refreshTokenTime",
//                                 getTokenExpiry(rfToken)
//                             );

//                             // ✅ reset popup flag
//                             alertShownRef.current = false;

//                             // ✅ timer restart
//                             // startTimer();
//                             // ✅ old timer clear
//                             clearInterval(timerRef.current);



//                             // ✅ restart timer
//                             startTimer();

//                         } catch (err) {

//                             console.log(
//                                 "Refresh API Failed",
//                                 err
//                             );

//                             onLogout();
//                         }

//                     } else {

//                         // ✅ logout click cheste
//                         onLogout();
//                     }
//                 });
//             }

//             // ✅ original expiry condition
//             if (remaining <= 0) {

//                 clearInterval(timerRef.current);

//                 Swal.fire({
//                     title: "Session Expired",
//                     text: "Please login again",
//                     icon: "warning",
//                     confirmButtonText: "OK",
//                     allowOutsideClick: false,
//                 }).then(() => onLogout());
//             }

//         };

//         updateTimer();
//         timerRef.current = setInterval(updateTimer, 1000);
//     };


//     console.log("time", timeLeft);
//     return (
//         <div className="session-timer-container">
//             <div className="timer-box">
//                 <span className="timer-text">{timeLeft}</span>
//             </div>


//         </div>
//     );
// }


import { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import axios from "axios";

import {
    calculateTimeLeft,
    formatTime,
    getTokenExpiry,
} from "./TimeUtility";

import { config } from "./CommonURLS";

export default function SessionTimer({
    onLogout,
    onProgress,
}) {

    const [timeLeft, setTimeLeft] = useState("--:--");

    const [progress, setProgress] = useState(100);

    const timerRef = useRef(null);

    // ✅ popup already shown aa leda
    const alertShownRef = useRef(false);

    useEffect(() => {

        startTimer();

        return () => {

            clearInterval(timerRef.current);
        };

        // eslint-disable-next-line
    }, []);

    const startTimer = () => {

        // ✅ latest refresh expiry every restart lo read chestundi
        const refreshExpiry =
            Number(Cookies.get("refreshTokenTime"));

        if (!refreshExpiry) return;

        // ✅ fresh duration calculate
        const initialDuration =
            refreshExpiry - Date.now();

        const updateTimer = async () => {

            // ✅ always latest expiry
            const latestRefreshExpiry =
                Number(Cookies.get("refreshTokenTime"));

            const remaining =
                calculateTimeLeft(latestRefreshExpiry);

            setTimeLeft(formatTime(remaining));

            // ✅ progress bar percentage
            const newProgress =
                initialDuration > 0
                    ? Math.max(
                        0,
                        (remaining / initialDuration) * 100
                    )
                    : 0;

            setProgress(newProgress);

            // ✅ parent callback
            if (onProgress) {

                onProgress(newProgress);
            }



            /* =========================================
               ✅ SHOW WARNING POPUP AT 10 SEC
            ========================================== */

            if (
                remaining <= 20000 &&
                remaining > 0 &&
                !alertShownRef.current
            ) {

                // ✅ avoid multiple popups
                alertShownRef.current = true;

                // ✅ stop timer while popup open
                clearInterval(timerRef.current);

                Swal.fire({
                    title: "Session Expiring Soon",
                    text: "Your session will expire in 20 seconds. Continue session?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Continue Session",
                    cancelButtonText: "Logout",
                    allowOutsideClick: false,
                }).then(async (result) => {

                    /* =========================================
                       ✅ USER CLICKED CONTINUE
                    ========================================== */

                    if (result.isConfirmed) {

                        try {

                            const refreshToken =
                                Cookies.get("refreshToken");

                            // ✅ no refresh token
                            if (!refreshToken) {

                                onLogout();

                                return;
                            }

                            const URL =
                                config.url.FAC_URL +
                                "auth/refresh-token";

                            // ✅ refresh api
                            const res =
                                await axios.post(URL, {
                                    refreshToken,
                                });

                            console.log(
                                "REFRESH RESPONSE",
                                res
                            );

                            // ✅ backend response structure support
                            const acToken =
                                res?.data?.data?.accessToken ||
                                res?.data?.accessToken;

                            const rfToken =
                                res?.data?.data?.refreshToken ||
                                res?.data?.refreshToken;

                            // ✅ invalid response
                            if (!acToken || !rfToken) {

                                console.log(
                                    "Invalid refresh response"
                                );

                                onLogout();

                                return;
                            }

                            /* =========================================
                               ✅ SAVE NEW TOKENS
                            ========================================== */

                            Cookies.set(
                                "token",
                                acToken
                            );

                            Cookies.set(
                                "refreshToken",
                                rfToken
                            );

                            Cookies.set(
                                "tokenTime",
                                getTokenExpiry(acToken)
                            );

                            Cookies.set(
                                "refreshTokenTime",
                                getTokenExpiry(rfToken)
                            );

                            console.log(
                                "Session Extended Successfully"
                            );

                            // ✅ reset popup flag
                            alertShownRef.current = false;

                            // ✅ clear old timer
                            clearInterval(timerRef.current);

                            // ✅ restart timer with NEW expiry
                            startTimer();

                        } catch (err) {

                            console.log(
                                "Refresh API Failed",
                                err
                            );

                            onLogout();
                        }

                    } else {

                        /* =========================================
                           ✅ USER CLICKED LOGOUT
                        ========================================== */

                        onLogout();
                    }
                });
            }

            /* =========================================
               ✅ SESSION EXPIRED
            ========================================== */

            if (remaining <= 0) {

                clearInterval(timerRef.current);

                Swal.fire({
                    title: "Session Expired",
                    text: "Please login again",
                    icon: "warning",
                    confirmButtonText: "OK",
                    allowOutsideClick: false,
                }).then(() => {

                    onLogout();
                });
            }
        };

        // ✅ initial call
        updateTimer();

        // ✅ every second update
        timerRef.current =
            setInterval(updateTimer, 1000);
    };

    return (
        <div className="session-timer-container">

            <div className="timer-box">

                <span className="timer-text">
                    {timeLeft}
                </span>

            </div>

        </div>
    );
}


